import { ABTestValue } from './types.js';
export const ABTestValueLabelMap = {
    [ABTestValue.Disabled]: 'Disabled',
    [ABTestValue.Enabled_DefaultFalse]: 'Enabled - Default False',
    [ABTestValue.Enabled_DefaultTrue]: 'Enabled - Default True',
};
//# sourceMappingURL=consts.js.map